import React from 'react';
import { Icon } from '@fiverr-private/fit';
import { s_info_circle } from '@fiverr-private/icons';
import PriceSummaryPopover, { SOURCE_COMPONENT } from '../../shared/PriceSummaryPopover';

import './style.scss';

const ServiceFeeIcon = ({ packageId }) => (
    <PriceSummaryPopover packageId={packageId} sourceComponent={SOURCE_COMPONENT.PACKAGES}>
        <Icon size={12} className="service-fee-icon">{s_info_circle}</Icon>
    </PriceSummaryPopover>
);

export default ServiceFeeIcon;
